<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="overlay-edit promise-history-min-width">
	<!-- Pin History Header -->
	<div class="h3-heading-bold">
		<span style="text-transform: capitalize">{{ ticketType }}</span> finish has been promised
		{{ totalPins }} times.
	</div>
	<div class="explanation-text">Below is a list of all the promises and their details.</div>
	<div
		*ngIf="(isEditing | async) && editForm.invalid && dirtyChildren"
		[shakeAnimation]="makeShake"
		class="explanation-text make-it-red"
	>
		{{ editForm.errors?.sameDateValidator?.message || 'Please correct all errors' }}
	</div>

	<!-- Pin History content -->
	<div class="overlay-content" #calendarPlace [ngClass]="{ 'resized-edit': isEditing | async }">
		<!-- view view -->
		<ng-container *ngIf="!(isEditing | async) as isEditingSync">
			<ng-template ngFor let-pin let-i="index" [ngForOf]="promiseStack">
				<!-- Displays for each pin -->
				<div class="promise-item" [ngClass]="{ 'promise-item--edit': !isEditingSync }">
					<div>
						<div>Promised:</div>
						<div>{{ pin.data?.plannedFinish }}</div>
					</div>
					<div>
						<div>Variance reason:</div>
						<div>{{ pin.data.variance?.varianceReason }}</div>
					</div>
					<div>
						<div>Status:</div>
						<div>{{ pin.data?.prettyState }}</div>
					</div>
					<div class="pin-container">
						<div
							class="pin-icon-circle pin-icon--remove-pointer"
							automationId="pinIconCircle"
							*ngIf="totalPins > 0"
							[ngStyle]="{ background: pin.data.color }"
						>
							<i class="pin-icon material-icons">push_pin</i>
						</div>
					</div>
					<div *ngIf="pin.data.varianceComment" class="variance-note-container">
						<div>Note:</div>
						<div>{{ pin.data.varianceComment }}</div>
					</div>
				</div>
			</ng-template>
			<div class="promise-item">
				<div>
					<div>{{ isActual ? 'Actual' : 'Planned' }}</div>
					<div>{{ ticketDate }}</div>
				</div>
			</div>
		</ng-container>

		<!-- edit view, isolated the whole container for less subscriptions -->
		<ng-container [formGroup]="editFormWrapped" *ngIf="isEditing | async as isEditingSync">
			<ng-container formArrayName="array" *ngFor="let pin of promiseStack; let i = index">
				<!-- Displays for each pin -->
				<div
					[formGroupName]="i"
					class="promise-item"
					[ngClass]="{ 'promise-item--edit': isEditingSync && isAdmin }"
				>
					<div [ngClass]="{ 'status-cell-edit': !isAdmin }">
						<div>Promised:</div>
						<div *ngIf="!isAdmin">{{ pin.data?.plannedFinish }}</div>
						<ticket-calendar
							*ngIf="isAdmin"
							[readOnly]="true"
							formControlName="plannedFinish"
							[editForm]="editFormWrapped"
						>
						</ticket-calendar>
					</div>
					<div>
						<div>Variance reason:</div>
						<ticket-variance
							formControlName="varianceId"
							placeholder=""
							errorOverlapsInput="true"
							[varianceList]="varianceList$"
						>
						</ticket-variance>
					</div>
					<div class="status-cell-edit">
						<div>Status:</div>
						<div>{{ pin.data?.prettyState }}</div>
					</div>
					<div class="pin-container center-cell-vertically">
						<div
							class="pin-icon-circle pin-icon--remove-pointer"
							automationId="pinIconCircle"
							*ngIf="totalPins > 0"
							[ngStyle]="{ background: pin.data.color }"
						>
							<i class="pin-icon material-icons">push_pin</i>
						</div>
					</div>
					<div *ngIf="isAdmin" class="center-cell-vertically">
						<i class="material-icons trash-icon" (click)="deletePin(i)" automationId="pinHistoryDelete"
							>delete</i
						>
					</div>
					<div class="variance-note-container--edit">
						<!-- show button -->
						<div *ngIf="!(hasExpandedNotes | async)[i]">
							<ng-container *ngIf="editForm.controls[i].get('varianceComment').enabled">
								<i class="material-icons menu-icon--blue plus-circle">add_circle</i>
								<a class="text-underline--grey" (click)="showNote(i)">Add Note</a>
							</ng-container>
							<ng-container *ngIf="editForm.controls[i].get('varianceComment').disabled">
								<i class="material-icons menu-icon--blue is-disabled plus-circle">add_circle</i>
								<a class="text-underline--grey is-disabled">Add Note</a>
							</ng-container>
						</div>
						<!-- show text area -->
						<div *ngIf="(hasExpandedNotes | async)[i]">
							<div>Note:</div>
							<textarea formControlName="varianceComment" automationId="pinHistoryVarianceComment"></textarea>
						</div>
					</div>
				</div>
			</ng-container>
			<div class="promise-item" *ngIf="!promiseStack">All promises deleted.</div>
			<div class="promise-item">
				<div>
					<div>{{ isActual ? 'Actual' : 'Planned' }}</div>
					<div>{{ ticketDate }}</div>
				</div>
			</div>
		</ng-container>
	</div>

	<!-- Footer -->
	<div class="justify-end">
		<button
			*ngIf="!(isEditing | async)"
			class="legacy-button button-sm--white horizontal-spacing-md"
			(click)="close(true)"
			automationId="pinHistoryClose"
		>
			Close
		</button>
		<button
			*ngIf="!(isEditing | async) && hasAccess"
			class="legacy-button button-sm--blue"
			(click)="switchToEdit()"
			automationId="pinHistoryEdit"
		>
			Edit
		</button>
		<button
			*ngIf="isEditing | async"
			class="legacy-button button-sm--white horizontal-spacing-md"
			(click)="cancel()"
			automationId="pinHistoryCancel"
		>
			Cancel
		</button>
		<button
			*ngIf="isEditing | async"
			[ngClass]="{ 'disabled-button': editForm.invalid }"
			class="legacy-button button-sm--blue"
			(click)="close()"
			automationId="pinHistoryDone"
		>
			Done
		</button>
	</div>
</div>
